module.exports = __webpack_public_path__ + "39cbd25ac81ffee55f0fbfc3a3d9bd9b.svg";